<nz-divider></nz-divider>
<h3>Action Details:</h3>
<form nz-form [formGroup]="actionCommentsGroup">
  <div nz-row>
    <div
      *ngIf="actions.length > 0"
      nz-col
      nzXl="12"
      nzLg="12"
      nzMd="24"
      nzSm="24"
      nzXs="24"
    >
      <nz-form-item class="mr-md">
        <nz-form-label nzRequired>Actions</nz-form-label>
        <nz-form-control nzValidateStatus="validating">
          <nz-select
            formControlName="selectedAction"
            id="action"
            [(ngModel)]="listSelectedAction"
            nzPlaceHolder="Select action"
          >
            <nz-option
              *ngFor="let action of actions"
              [nzValue]="action"
              [nzLabel]="action"
            ></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24" nzXs="24">
      <nz-form-item class="ml-lg">
        <nz-form-label>Comments</nz-form-label>
        <nz-form-control nzValidateStatus="validating">
          <textarea
            rows="2"
            formControlName="comments"
            id="comments"
            nz-input
            placeHolder="Comments"
          ></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzXl="24" nzLg="24" nzMd="24" nzSm="24" nzXs="24">
      <div class="float-right">
        <button
          [disabled]="!actionCommentsGroup.valid"
          nz-button
          nzType="primary"
          (click)="onSubmit()"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</form>
